"use client";
import { jsx as s } from "react/jsx-runtime";
import { forwardRef as l } from "react";
import { withCmsBackofficeHandling as m } from "../withCmsBackofficeHandling/withCmsBackofficeHandling.js";
import { checkApiFormat as f, getBackofficeLink as u, dictionaryApiParser as y } from "./helpers.js";
const h = ({
  Component: a,
  deliveryApiParser: c
}) => l((d, n) => {
  const { data: r, ...e } = d, p = r ? f(r) : null;
  if (p === "delivery" && c !== void 0) {
    let t = r;
    Object.prototype.hasOwnProperty.call(r, "content") && (t = r, t = {
      ...t,
      ...t.content,
      properties: {
        ...t.content.properties,
        areas: t.areas,
        settings: t.settings,
        rowSpan: t.rowSpan,
        columnSpan: t.columnSpan,
        areaGridColumns: t.areaGridColumns
      }
    });
    let o = c;
    Object.prototype.hasOwnProperty.call(e, "customParser") && (o = e.customParser, delete e.customParser);
    const i = {
      ...o(t),
      ...e
    };
    return /* @__PURE__ */ s(a, { ref: n, ...i });
  }
  if (p === "dictionary") {
    const t = r, o = u(t), i = {
      ...y(t),
      ...e
    };
    return m(
      /* @__PURE__ */ s(a, { ref: n, ...i }),
      o?.editLink ? o : void 0
    );
  }
  return /* @__PURE__ */ s(a, { ref: n, ...e });
});
export {
  h as withCmsDataHandling
};
